var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"print"}},[_c('iframe',{attrs:{"id":"printIframe","src":_vm.imgUrl,"frameborder":"0","width":"100%","height":"100%"},on:{"load":function($event){return _vm.resize()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }